<template>
  <div>
    <section class="has-listing-table">
      <div class="level no-margin">
        <div class="level-left">
          <span class="navbar-item no-padding">
            <h3 class="no-padding">Products</h3>
          </span>
          <span class="navbar-item">
            <multiselect
              :disabled="switchCustomerViewEnabled"
              :value="tenatSchemas.id"
              v-model="customer"
              :options="tenatSchemas"
              placeholder="Please select a customer"
              label="name"
              track-by="name"
              :searchable="true"
              @input="changeCustomer()"
            ></multiselect>
          </span>
          <span
            class="navbar-item"
            v-if="customer"
            style="padding-bottom: 12px;"
          >
            <a
              @click.prevent="handleUnmatch()"
              style="padding-right: 10px;"
              data-cy="certificate-manual-unmatch"
              >Unmatch</a
            >
          </span>
          <b-field v-if="customer">
            <b-select
              placeholder="Default"
              expanded
              @input="changeStream()"
              v-model="stream"
            >
              <option selected value="PRODUCT SHEET">Products</option>
              <option value="PACK" v-if="availableStream['PACK']">
                Packaging
              </option>
            </b-select>
          </b-field>
        </div>
        <div class="level-right page-configs">
          <!-- Add Column Configuration Dropdown -->
          <b-dropdown
            position="is-bottom-left"
            @active-change="onDropdownActiveChange"
            style="margin-bottom: 10px;"
          >
            <template #trigger>
              <a class="navbar-item navbar-mdi-tune-dropdown">
                <button class="button" data-cy="product-config-button">
                  <span class="mdi mdi-table-cog mdi-24px mdi-dark"></span>
                </button>
              </a>
            </template>
            <form>
              <div class="filter-config-modal-body">
                <!-- Fixed header that won't scroll -->
                <div class="filter-config-header">
                  <b-field label="Column Configuration">
                    <div style="padding: 4px 0;">
                      <b-checkbox v-model="selectAll" @input="toggleSelectAll">
                        <strong>Select All</strong>
                      </b-checkbox>
                    </div>
                  </b-field>
                </div>
                <!-- Scrollable content section -->
                <section class="filter-config-list">
                  <div
                    v-for="(column, index) in columns"
                    :key="index"
                    class="control"
                  >
                    <div v-if="column.label != ''">
                      <b-dropdown-item
                        aria-role="list"
                        :focusable="false"
                        custom
                        paddingless
                      >
                        <b-checkbox
                          @input="saveFieldConfig()"
                          v-model="column.visible"
                        >
                          {{ column.label }}
                        </b-checkbox>
                      </b-dropdown-item>
                    </div>
                  </div>
                </section>
              </div>
            </form>
          </b-dropdown>
        </div>
      </div>
      <div class="enable-select-text">
        <circul8-table
          class="no-padding"
          ref="circul8Table"
          @clickcheck="checkCheckBox"
          @checkedAll="checkedAllData"
          :checkedRows="checkedRow"
          :records="tableData"
          :fields="columns.filter(col => col.visible !== false)"
          :usePropRecords="true"
          :listingComponent="true"
          :isCheckable="stream === 'PACK'"
          :maxTextLength="'24'"
          :isLoading="isDataLoading"
          @querySet="searchByFilter"
          :backendSortingEnabled="true"
          :routeNext="false"
          :showEditButton="isEditAllowed"
          @backendSort="sortData"
          @clickEdit="editModal"
          @clickView="viewModal"
          :showRemoveButton="false"
          :enableInfiniteScroll="true"
          :allProductFamily="productFamily"
          :allMaterialDetail="materialDetail"
          :productFamilyDropDown="productFamilyDropDown"
          :materialDetailDropDown="materialDetailDropDown"
          :chemistryDropDown="chemistryDropDown"
          :packagingTypeDropDown="packagingTypeDropDown"
          :packagingLevelDropDown="packagingLevelDropDown"
          @loadNextPage="pullNextPage"
          :hasNextData="nextData"
          :hasPreviousData="previousData"
          @loadPreviousPage="pullPreviousPage"
          :isCheckAll="true"
          :newTableHeight="newTableHeight"
        />
        <div class="records-displayed" v-if="totalRecords > 0">
          <span v-if="isCheckedAll"> All selected, </span>
          <span v-if="checkedData.length > 0 && !isCheckedAll"
            >{{ checkedData.length }} selected,
          </span>
          <span v-if="currentPage * 50 + 50 < totalRecords"
            >displaying {{ currentPage > 1 ? currentPage * 50 - 50 : 0 }} -
            {{
              currentPage > 0
                ? nextPageCursor
                  ? currentPage * 50 - 50 + tableData.length
                  : totalRecords
                : tableData.length
            }}
            records out of {{ totalRecords }} records</span
          >
          <div v-else>
            <span v-if="currentPage == 0">
              displaying 0 - {{ totalRecords }} records out of
              {{ totalRecords }} records
            </span>
            <span v-else>
              displaying {{ currentPage * 50 - 50 }} -
              {{ totalRecords }} records out of {{ totalRecords }} records
            </span>
          </div>
        </div>
        <b-loading
          :is-full-page="true"
          v-model="isLoading"
          :can-cancel="false"
        ></b-loading>
        <!-- <product-mapping-filters
          :is-active="isFilterModalActive"
          :columns="columns"
          :current-filters="filterValues"
          :all-stream-columns="allStreamColumns"
          @applyFilters="applyFilters"
          @cancel="filterCancel"
        /> -->
        <single-product-edit
          :is-active="isModalActive"
          :customer-id="Number(this.customer.id)"
          :action="action"
          :edit-object-name="editObject"
          @confirm="editConfirm"
          @cancel="editCancel"
          :columns="this.columns"
          @updateSingleData="updatedSingleProduct"
          :allProductFamily="productFamily"
          :allMaterialDetail="materialDetail"
          :columnsConfig="this.cdf_product_config_sheet"
          :materialGeneralDropdown="materialGeneralDropdown"
          :chemistryDropDown="chemistryDropDown"
          :packagingTypeDropDown="packagingTypeDropDown"
          :packagingLevelDropDown="packagingLevelDropDown"
        />
        <bulk-product-edit
          :is-active="isCardModalBulkEditActive"
          :customer-id="Number(this.customer.id)"
          @cancel="editBulkCancel"
          :columns="this.columns"
          :columnsConfig="this.cdf_product_config_sheet"
          :checkedRows="this.checkedRow"
          :isCheckedAllRows="this.isCheckedAll"
          :stream="this.stream"
          :tempProduct="false"
          @reload="reloadProductData"
          :query="this.query"
        />
      </div>
    </section>
  </div>
</template>

<script>
import CustomerProfileDataService from "../../../services/CustomerProfileDataService";
import CDFProductDataService from "../../../services/CDFProductDataService";
import DataManagementService from "../../../services/DataManagementImportService";
import DataManagementCertificatesService from "../../../services/DataManagementCertificatesService";
import Circul8Table from "../../Circul8Table.vue";
import SingleProductEdit from "@/components/DataManagement/SingleProductEdit";
import BulkProductEdit from "@/components/DataManagement/BulkProductEdit";
import { CDFStream } from "../../../constants/CDFStream";
import { FieldType } from "../../../constants/FieldType";
import { UserGroup } from "@/services/UserGroups";
import { mapGetters } from "vuex";
import UtilityMixin from "@/mixins/UtilityMixin";
import ProductMixin from "@/mixins/ProductMixin";
import ErrorMixin from "@/mixins/ErrorMixin";
import UserPermissionMixin from "@/mixins/UserPermissionMixin";
import * as dayjs from "dayjs";
import Multiselect from "vue-multiselect";

let screenPixelSize;
let pixelRatio;
export default {
  name: "DataManagementProducts",
  mixins: [UtilityMixin, ProductMixin, ErrorMixin, UserPermissionMixin],
  components: {
    Circul8Table,
    SingleProductEdit,
    BulkProductEdit,
    Multiselect
  },
  data() {
    return {
      checkedData: [],
      checkedRow: [],
      map1: new Map(),
      isCheckedAll: false,
      checkedDataMap: new Map(),
      nextPageCursor: "",
      PreviousPageCursor: "",
      loadMoreClicked: false,
      lastSortColumn: null,
      lastSortOrder: null,
      enableLoadMore: false,
      totalRecords: 0,
      isLoading: false,
      nextData: false,
      previousData: false,
      currentPage: 0,
      query: "",
      isDataLoading: false,
      stream: "PRODUCT SHEET",
      availableStream: {},
      customer: "",
      form: [],
      customers: [],
      cdf_product_sheet: [],
      customerDataService: new CustomerProfileDataService(),
      CDFProductDataService: new CDFProductDataService(),
      DataManagementService: new DataManagementService(),
      DataManagementCertificatesService: new DataManagementCertificatesService(),
      columns: [],
      tableData: [],
      isModalActive: false,
      isBulkExportModal: false,
      isCardModalBulkEditActive: false,
      cdf_product_config_sheet: [],
      editObject: {},
      action: "",
      productFamily: {},
      productGroupDropDown: [],
      productFamilyDropDown: [],
      materialDetailDropDown: [],
      materialGeneralDropdown: [],
      packagingTypeDropDown: [],
      packagingLevelDropDown: [],
      chemistryDropDown: [],
      tenatSchemas: [],
      materialDetail: {},
      subHeight: 280, // Reduced to better fit with table height
      isDataCompletion: false,
      isFilterModalActive: false,
      switchCustomerId: null,
      switchCustomerViewEnabled: false,
      isBulkCommentModal: false,
      exportLargeCount: 65000,
      selectAll: true,
      allStreams: [
        CDFStream.PRODUCT_SHEET,
        CDFStream.BATT,
        CDFStream.PACK,
        CDFStream.WEEE,
        CDFStream.BUNDLE
      ],
      filterValues: {
        "PRODUCT SHEET": { query: "&" },
        BATT: { query: "&" },
        PACK: { query: "&" },
        WEEE: { query: "&" },
        "BUNDLE INFORMATION": { query: "&" }
      },
      allStreamColumns: {
        "PRODUCT SHEET": [],
        BATT: [],
        PACK: [],
        WEEE: [],
        "BUNDLE INFORMATION": []
      }
    };
  },
  computed: {
    ...mapGetters([
      "userId",
      "userName",
      "userHasPermission",
      "userGroups",
      "mappedCustomer",
      "switchCustomerView"
    ]),
    isEditAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        // this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE)
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        return true;
      } else {
        return false;
      }
    },
    titleStack() {
      return [
        { url: "#", name: "Data Management" },
        { url: "/datamangement/products", name: "Products" }
      ];
    },
    isViewOnlyUser() {
      if (this.userGroups.includes(UserGroup.VIEW_ONLY)) {
        return true;
      }
      return false;
    }
  },
  props: {
    customerId: { type: Number, default: -1 },
    newTableHeight: { type: [Number, String], default: null },
    matchClicked: { type: Number, default: 0 }
  },
  mounted() {
    this.fetchTenantSchemaData();
    const switchCustomerData = this.fetchSwitchCustomerCache();
    if (switchCustomerData != null) {
      this.switchCustomerViewEnabled =
        switchCustomerData["isSwitchCustomerView"];
      this.switchCustomerId = switchCustomerData["switchCustomerNumber"];
    }
    if (this.mappedCustomer && this.mappedCustomer.length > 0) {
      this.switchCustomerViewEnabled = true;
      this.getCustomerById();
    } else {
      this.fetchCustomerData();
    }
    if (this.customerId || this.switchCustomerId) {
      this.getCustomerById();
    }

    // All columns will be visible by default since we cleared localStorage

    // Set up resize event listener to adjust height
    window.addEventListener("resize", this.adjustHeight);

    // Initial height adjustment
    this.$nextTick(() => {
      this.adjustHeight();
    });
  },

  beforeDestroy() {
    // Clean up resize event listener
    window.removeEventListener("resize", this.adjustHeight);
  },
  methods: {
    handleUnmatch() {
      try {
        if (!this.customer?.id) {
          this.$buefy.dialog.alert({
            title: "Unmatch is Not Possible",
            message: "Please select a customer before unmatching."
          });
          return;
        }
        if (!this.checkedData.length) {
          this.$buefy.dialog.alert({
            title: "Unmatch is Not Possible",
            message: "Please select at least one record to unmatch."
          });
          return;
        }
        this.DataManagementCertificatesService.manualUnmatch(
          this.checkedData.map(record => record.id),
          this.customer?.id
        ).subscribe(
          () => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Selected entries have been unmatched!"
            });
            this.checkedData = [];
            this.checkedRow = [];
            this.map1 = new Map();
            this.isCheckedAll = false;
            this.checkedDataMap = new Map();
            // Reset table data before fetching
            this.tableData = [];
            this.currentPage = 0;
            this.nextPageCursor = null;
            this.nextData = false;
            this.previousData = false;
            this.fetchProductData(this.stream, this.query);
          },
          e => {
            this.handleApiError(e);
          }
        );
      } catch (e) {
        this.$buefy.dialog.alert({
          title: "Unmatch is Not Possible",
          message: e.message
        });
      }
    },
    fetchTenantSchemaData() {
      this.isDataLoading = true;
      this.customerDataService.getParentCustomerListWithPublic().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.tenatSchemas = data;
          this.isDataLoading = false;
        },
        () => {
          this.isDataLoading = false;
        }
      );
    },
    toggleSelectAll() {
      this.columns.forEach(column => {
        if (column.field !== "actions") {
          column.visible = this.selectAll;
        }
      });
      this.columnsForConfig = [...this.columns];
      this.saveFieldConfig();
    },
    saveFieldConfig() {
      // Get visible column fields based on current checkbox selections
      const visibleFields = this.columns
        .filter(col => col.visible === true)
        .map(col => col.field);

      // Create a stream-specific storage key
      const customerId = this.$route.params.customerId || this.customer.id;
      const storageKey = `productCertMappingFields-${
        this.userId
      }-customer-${customerId}-stream-${this.stream.replace(/\s+/g, "_")}`;

      // Save to localStorage with stream-specific key
      localStorage.setItem(storageKey, JSON.stringify(visibleFields));

      // Force a re-render of the table with only visible columns
      this.$nextTick(() => {
        if (this.$refs.circul8Table) {
          this.$refs.circul8Table.$forceUpdate();
        }

        // After the DOM update, recalculate the table height to fill available space
        this.adjustHeight();
      });
    },
    openDataCompletionModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Warning",
          message: "Please choose the record(s) you want to update.",
          confirmText: "Close",
          ariaRole: "alertdialog",
          ariaModal: true
        });
      }
    },
    openRevertModal() {
      if (this.checkedRow.length || this.isCheckedAll) {
        this.isDataCompletion = true;
      }
    },
    dataCompletionCancel(str) {
      if (str !== "reload") {
        this.reloadProductData();
      }
      this.isDataCompletion = false;
    },
    filterCancel() {
      this.isFilterModalActive = false;
    },
    applyFilters(allStreamQueries, allStreamFilterData) {
      // Receives queries and filter data for all streams from the modal
      this.isFilterModalActive = false;

      // Process each stream's query and filter data
      Object.keys(allStreamQueries).forEach(streamName => {
        const filterQuery = allStreamQueries[streamName];
        const filterData = allStreamFilterData[streamName] || [];

        // Store the structured filter data with the query
        this.filterValues[streamName] = {
          filters: filterData,
          query: filterQuery
        };
      });

      // Reset pagination and selection
      this.resetPaginationAndSelection();

      // Use the query for the current stream
      this.query = this.filterValues[this.stream].query;
      this.query += `&is_active=${this.stream}&`;
      // Add sorting if needed
      let queryWithSort = this.query;
      if (this.lastSortColumn) {
        if (!queryWithSort.includes(`order_field=${this.lastSortColumn}`)) {
          queryWithSort = `&order_field=${this.lastSortColumn}&order_by=${
            this.lastSortOrder
          }&${queryWithSort.substring(1)}`;
        }
      }

      // Fetch data with the clean query
      this.fetchProductData(this.stream, queryWithSort);
    },
    fetchAdditionalDropDownVal(customerId) {
      try {
        this.DataManagementService.getAdditionalDropdowns(customerId).subscribe(
          response => {
            this.productFamilyDropDown = this.prepareDropDownArray(
              response.product_family
            );
            this.productGroupDropDown = this.prepareDropDownArray(
              response.product_group
            );
            this.materialDetailDropDown = this.prepareDropDownArray(
              response.material_detail
            );
            this.materialGeneralDropdown = this.prepareDropDownArray(
              response.material_general
            );
            this.packagingTypeDropDown = this.prepareDropDownArray(
              response.packaging_type
            );
            this.chemistryDropDown = this.prepareDropDownArray(
              response.chemistry
            );
            this.packagingLevelDropDown = this.prepareDropDownArray(
              response.packaging_level
            );
          },
          e => {
            console.log(e);
          }
        );
      } catch (e) {
        console.log(e);
      }
    },
    prepareDropDownArray(value) {
      const result = [];

      if (!value || (Array.isArray(value) && value.length === 0)) {
        return result;
      }

      // Handle string arrays
      if (Array.isArray(value) && typeof value[0] === "string") {
        value.forEach(element => {
          const obj = {};
          obj["name"] = element;
          result.push(obj);
        });
      }
      // Handle nested object arrays (like product_family with categories as keys)
      else if (
        Array.isArray(value) &&
        typeof value[0] === "object" &&
        value[0] !== null
      ) {
        const firstItem = value[0];
        // If it's a mapping object with arrays as values (for product_family, material_detail)
        if (Object.keys(firstItem).length > 0) {
          Object.keys(firstItem).forEach(key => {
            const obj = {};
            obj["name"] = key;
            result.push(obj);
          });
        }
      }

      return result;
    },
    saveBulkComment(data) {
      this.isBulkCommentModal = false;
      this.CDFProductDataService.saveBulkComment(
        this.customer.id,
        this.checkedData.map(records => records.id),
        this.query,
        this.isCheckedAll,
        data,
        this.stream
      ).subscribe(
        () => {
          this.checkedData = [];
          this.map1 = new Map();
          this.checkedRow = [];
          this.isCheckedAll = false;
          this.$buefy.dialog.alert({
            title: "Success",
            message: "Comment(s) Created!",
            onConfirm: () => this.getCustomerById()
          });
        },
        e => {
          this.handleApiError(e);
          this.isLoading = false;
        }
      );
    },
    cancelBulkComment() {
      this.isBulkCommentModal = false;
    },
    BulkComments() {
      if (this.checkedData.length > 0) {
        this.isBulkCommentModal = true;
      } else {
        this.$buefy.dialog.alert({
          title: "Comment is Not Possible",
          message: "Please select at least one record"
        });
      }
    },
    exportProducts() {
      try {
        this.CDFProductDataService.exportProducts(
          this.customer.id,
          "Products",
          this.stream,
          this.checkedData.map(records => records.id)
        );
      } catch (e) {
        this.handleApiError(e);
      }
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      //this.fetchCDFProductData(this.customer.id);
    },
    revertDataCompletionRule(bulkAction) {
      if (bulkAction == "revert") {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message:
            "Are you sure you want to revert data completion rule on these records?",
          trapFocus: true,
          onConfirm: value => this.revertDc(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    additionalBulkCheck(bulkAction) {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg =
          `Are you sure you want to export ` +
          (this?.isCheckedAll
            ? `all`
            : `selected ` + this?.checkedData?.length) +
          ` records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }
      if (this.checkedData.length > 50 || this.isCheckedAll) {
        this.$buefy.dialog.confirm({
          title: "Confirmation",
          confirmText: "Yes",
          message: msg,
          trapFocus: true,
          onConfirm: value => this.exportAllProducts(value, bulkAction)
        });
      } else {
        this.functionCallingMethod(false, bulkAction);
      }
    },
    completeProductExport() {
      let msg = "";
      if (this.totalRecords < this.exportLargeCount) {
        msg = `Are you sure you want to export all records?`;
      } else {
        msg =
          `Are you sure you want to export more than ` +
          this.exportLargeCount +
          ` records? Exported file will be sent to your email address`;
      }
      this.$buefy.dialog.confirm({
        title: "Confirmation",
        confirmText: "Yes",
        message: msg,
        trapFocus: true,
        onConfirm: value => this.exportCompleteProducts(value)
      });
    },
    exportAllProducts() {
      this.isLoading = true;

      this.CDFProductDataService.exportAllProducts(
        this.customer.id,
        "Products",
        this.stream,
        this.query,
        this.totalRecords
      ).subscribe(
        () => {
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
      this.isCheckedAll = false;
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
    },
    exportCompleteProducts() {
      this.isLoading = true;

      this.CDFProductDataService.exportCompleteProducts(
        this.customer.id,
        "Products"
      ).subscribe(
        () => {
          this.isLoading = false;
        },
        () => {
          this.isLoading = false;
        }
      );
    },
    revertDc() {
      this.isLoading = true;
      this.tableData = [];
      this.DataManagementService.dataRevert(this.customer.id, null).subscribe(
        () => {
          this.isLoading = false;
          this.fetchProductData(this.stream, this.query);
        },
        this.handleRevertError
      );
    },
    handleRevertError(reason) {
      let errorMessage = reason.response.data["detail"];
      this.isLoading = false;
      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Some issue while updating status";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.fetchProductData(this.stream, this.query);
    },

    functionCallingMethod(value, bulkAction) {
      this.isCheckedAll = false;
      switch (bulkAction) {
        case "exportProducts":
          this.exportProducts();
          break;
      }
    },
    reloadProductData() {
      this.tableData = [];
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      //this.fetchProductData(this.stream, this.query);
      //this.fetchCDFProductData(this.customer.id, this.query);
      this.fetchProductData(this.stream, this.query);
    },
    editConfirm() {
      this.isModalActive = false;
      this.getCustomerById();
      //this.$router.go();
    },
    editCancel() {
      this.isModalActive = false;
    },
    viewConfirmExport() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewCancel() {
      this.checkedData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isBulkExportModal = false;
    },
    viewModal(editObject) {
      this.action = "View";
      this.editObject = editObject;
      this.checkDependency(editObject);
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.action = "Edit";
      this.checkDependency(editObject);
      this.isModalActive = true;
    },
    find_column_index(column_name) {
      return this.columns.findIndex(col => col.field === column_name);
    },
    pushValueToColumn(index, column_name, flag) {
      this.columns[index]["allStatusVals"] = [];
      if (
        flag == "materialDetail" &&
        this.materialDetail[`${column_name}`] &&
        this.materialDetail[`${column_name}`].length > 0
      ) {
        for (const element of this.materialDetail[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
      if (
        flag == "productFamily" &&
        this.productFamily[`${column_name}`] &&
        this.productFamily[`${column_name}`].length > 0
      ) {
        for (const element of this.productFamily[`${column_name}`]) {
          this.columns[index]["allStatusVals"].push({
            name: element
          });
        }
      }
    },
    checkDependency(item) {
      const ProductFamilyIndex = this.find_column_index("product_family");
      if (ProductFamilyIndex > 0) {
        this.pushValueToColumn(
          ProductFamilyIndex,
          item.product_group,
          "productFamily"
        );
      }
      const materialDetailIndex = this.find_column_index("material_detail");
      if (materialDetailIndex > 0) {
        this.pushValueToColumn(
          materialDetailIndex,
          item.material_general,
          "materialDetail"
        );
      }
    },
    updatedSingleProduct(editedObject) {
      this.DataManagementService.getOrUpdateProductData(
        0, // as this is only for public user, so passing 0
        this.stream,
        this.$route.params.id,
        "",
        "",
        editedObject,
        true
      ).subscribe(() => {
        this.$buefy.toast.open({
          message: "Data is updated successfully!",
          type: "is-success"
        });
        this.getCustomerById();
        this.isModalActive = false;
      }, this.handleApiError);
    },
    getCustomerById() {
      let customerId = this.customerId;
      if (this.switchCustomerId) {
        customerId = this.switchCustomerId;
      }
      if (this.mappedCustomer.length > 0) {
        customerId = this.mappedCustomer[0];
      }
      this.customerDataService.getCustomerById(customerId).subscribe(
        response => {
          this.isLoading = false;
          this.customer = response;
          this.changeCustomer();
        },
        e => {
          console.log(e);
        }
      );
    },
    checkedAllData(value) {
      // Multiple selection mode - support select all
      this.isCheckedAll = value;
      if (!this.isCheckedAll) {
        this.checkedRow = [];
        this.map1 = new Map();
        this.checkedDataMap = new Map();
        this.checkedData = [];
      } else {
        this.checkedDataMap.set(this.currentPage, this.tableData);
        this.checkedData = [...this.tableData];
        this.checkedRow = this.tableData;
      }
      this.$emit("selectedRows", this.checkedData, this.customer?.id || null);
    },
    checkCheckBox(d) {
      // Multiple selection mode
      const total_checked = this.checkedData.length;
      const indexs = [];
      // Getting the index of the checked rows
      d.forEach(element => {
        const index = this.tableData.findIndex(object => {
          return element.id === object.id;
        });
        indexs.push(index);
      });
      // Create 2 dictionaries: one with indexes for showing current page selected, another with checked row values
      this.map1.set(this.currentPage, indexs);

      if (d.length > 0) {
        this.checkedDataMap.set(this.currentPage, d);
      } else {
        !this.isCheckedAll && this.checkedDataMap.set(this.currentPage, d);
      }
      this.checkedRow = d;
      this.checkedData = [];
      // Converting mapped data into array for bulk operations
      this.checkedDataMap.forEach(element => {
        this.checkedData.push(...element);
      });
      // If checked all is true and deselect any
      if (this.isCheckedAll && total_checked > this.checkedData.length) {
        this.isCheckedAll = false;
        this.checkedDataMap = new Map();
        this.checkedData = [];
        this.checkedRow = [];
        this.map1 = new Map();
      }
      this.$emit("selectedRows", this.checkedData, this.customer?.id || null);
    },
    // Basic column filtering from the table (like Products.vue)
    searchByFilter(filterQuery) {
      // Parse filter query from table column filters
      this.filterValues[this.stream] = {};

      const queryParams = new Map();

      if (filterQuery) {
        filterQuery.split("&").forEach(pair => {
          if (pair) {
            const [key, value] = pair.split("=");
            if (key && value) {
              queryParams.set(key, decodeURIComponent(value));
            }
          }
        });
      }

      // Always set is_active parameter to the current stream
      queryParams.set("is_active", this.stream);

      // Build filter values object for the current stream
      queryParams.forEach((value, key) => {
        if (key === "is_active") {
          return;
        }

        if (!this.filterValues[this.stream][key]) {
          this.filterValues[this.stream][key] = [];
        }

        this.filterValues[this.stream][key] = [
          {
            value: value,
            field: key
          }
        ];
      });

      // Build query string for the current stream
      let streamQuery = "&";
      const streamParams = [];

      Object.keys(this.filterValues[this.stream] || {}).forEach(key => {
        if (key !== "query" && this.filterValues[this.stream][key].length > 0) {
          const filterValue = this.filterValues[this.stream][key][0].value;
          streamParams.push(`${key}=${encodeURIComponent(filterValue)}`);
        }
      });

      if (streamParams.length > 0) {
        streamQuery += streamParams.join("&") + "&";
      }

      this.filterValues[this.stream].query = streamQuery;

      // Reset pagination and selection
      this.resetPaginationAndSelection();

      this.query = streamQuery;

      // Add sorting if needed
      let queryWithSort = this.query;
      if (this.lastSortColumn) {
        if (!queryWithSort.includes(`order_field=${this.lastSortColumn}`)) {
          queryWithSort = `&order_field=${this.lastSortColumn}&order_by=${
            this.lastSortOrder
          }&${queryWithSort.substring(1)}`;
        }
      }

      this.fetchProductData(this.stream, queryWithSort);
    },

    // Helper method to reset pagination and selection state
    resetPaginationAndSelection() {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
    },

    pullNextPage() {
      this.previousData = true;
      this.loadMoreClicked = true;
      this.currentPage = this.currentPage + 1;

      // Always start with the complete filter query from the stored filters
      let baseQuery = this.filterValues[this.stream].query || "&";

      // Remove any existing page parameter to avoid duplication
      baseQuery = baseQuery.replace(/&page=\d+&/g, "&");

      // Add the new page parameter
      const query = `${baseQuery}page=${this.currentPage + 1}&`;

      // Ensure consistent formatting (no duplicate &)
      const cleanQuery = query
        .replace(/&&/g, "&")
        .replace(/^&/, "&")
        .replace(/&$/, "&");

      // Update both the local query and the stored filter query
      this.query = cleanQuery;
      this.filterValues[this.stream].query = cleanQuery;

      // Fetch with updated query
      this.fetchProductData(this.stream, cleanQuery, "next");
    },

    pullPreviousPage() {
      this.nextData = true;
      this.loadMoreClicked = true;

      // Always start with the complete filter query from the stored filters
      let baseQuery = this.filterValues[this.stream].query || "&";

      // Remove any existing page parameter to avoid duplication
      baseQuery = baseQuery.replace(/&page=\d+&/g, "&");

      // Calculate the page number
      const pageNumber = this.currentPage <= 1 ? 1 : this.currentPage - 1;

      // Add the page parameter
      const query = `${baseQuery}page=${pageNumber}&`;

      // Ensure consistent formatting (no duplicate &)
      const cleanQuery = query
        .replace(/&&/g, "&")
        .replace(/^&/, "&")
        .replace(/&$/, "&");

      // Update both the local query and the stored filter query
      this.query = cleanQuery;
      this.filterValues[this.stream].query = cleanQuery;

      this.currentPage =
        this.currentPage > 0 ? this.currentPage - 1 : this.currentPage;
      this.fetchProductData(this.stream, cleanQuery, "prev");
    },
    sortData(field, order) {
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.tableData = [];
      this.nextData = false;
      // sort should always fetch page 1, so removing page param if exist
      this.query = this.query.replace(/page=[0-9.]{1,2}&/g, "");
      const oldOrderField = "&order_field" + "=" + this.lastSortColumn + "&";
      const oldOrderValue = "&order_by" + "=" + this.lastSortOrder + "&";
      const newOrderField = "&order_field" + "=" + field + "&";
      const newOrderValue = "&order_by" + "=" + order + "&";

      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderField,
        newOrderField
      );
      this.query = this.replaceOrAddParanInSearchQuery(
        oldOrderValue,
        newOrderValue
      );

      //     this.displayedRecords = 0;
      this.lastSortColumn = field;
      this.lastSortOrder = order;
      this.fetchProductData(this.stream, this.query);
    },

    replaceOrAddParanInSearchQuery(oldParam, newParam) {
      if (this.query.includes(oldParam)) {
        this.query = this.query.replace(oldParam, newParam);
      } else {
        this.query += newParam;
      }
      return this.query;
    },
    changeCustomer() {
      this.columns = [];
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.nextData = false;
      this.fetchCDFProductData(this.customer.id);
    },
    changeStream() {
      this.query = this.filterValues[this.stream].query || "";
      this.isCheckedAll = false;
      this.checkedDataMap = new Map();
      this.checkedData = [];
      this.checkedRow = [];
      this.map1 = new Map();
      this.tableData = [];
      this.totalRecords = 0;
      this.loadMoreClicked = false;
      this.nextPageCursor = null;
      this.currentPage = 0;
      this.nextData = false;
      this.$refs.circul8Table.clearDataWithoutReload();
      this.prepareColumns(this.cdf_product_sheet, this.stream);
    },

    prepareColumnsForStream(data, stream) {
      // Prepare columns for a specific stream without fetching data
      // This is used to populate allStreamColumns for the filter modal
      const usedFieldNames = new Set();
      const cdf_columns = data[0]["template_fields"];
      let cdf_product_sheet = [];

      if (stream == CDFStream.BATT) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BATT
        );
      } else if (stream == CDFStream.PACK) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PACK
        );
      } else if (stream == CDFStream.WEEE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.WEEE
        );
      } else if (stream == CDFStream.BUNDLE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BUNDLE
        );
      } else {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PRODUCT_SHEET
        );
      }

      const streamColumns = [];

      cdf_product_sheet.forEach((e, index) => {
        if (e.field_required == false) {
          return;
        }

        let type = "";
        type = this.getFieldType(e.field_type);
        let allStatusVals = [];

        if (e.dropdown_field_values?.length > 0) {
          e.dropdown_field_values.forEach(element => {
            if (e.product_data_column == "product_family") {
              allStatusVals = this.productFamilyDropDown;
            } else if (e.product_data_column == "material_detail") {
              allStatusVals = this.materialDetailDropDown;
            } else {
              allStatusVals.push({ name: element });
            }
          });
        }

        if (e.product_data_column == "product_group") {
          allStatusVals = this.productGroupDropDown;
        }
        if (e.product_data_column == "material_general") {
          allStatusVals = this.materialGeneralDropdown;
        }
        if (e.product_data_column == "packaging_type") {
          allStatusVals = this.packagingTypeDropDown;
        }
        if (e.product_data_column == "chemistry") {
          allStatusVals = this.chemistryDropDown;
        }

        let field_name = e.product_data_column;

        if (usedFieldNames.has(field_name)) {
          field_name = `${field_name}_${index}`;
        }
        usedFieldNames.add(field_name);

        const label_name =
          e.field_name.charAt(0).toUpperCase() +
          e.field_name.slice(1).toLowerCase();

        streamColumns.push({
          field: field_name,
          label: label_name,
          searchable: true,
          type: type,
          allStatusVals: allStatusVals,
          visible: true
        });
      });

      // Add common columns
      streamColumns.push({
        field: "external_comment",
        label: "External User Comment",
        searchable: true,
        type: "input",
        visible: true
      });

      if (stream !== "Transactions") {
        streamColumns.push({
          field: "dc_applied",
          label: "Data Completion Applied",
          searchable: true,
          type: "multiSelectFilter",
          allStatusVals: [{ name: "yes" }, { name: "no" }],
          visible: true
        });
        streamColumns.push({
          field: "data_comp_rules",
          label: "Data Completion Rule",
          searchable: true,
          type: "input",
          visible: true
        });
        streamColumns.push({
          field: "dc_created_at",
          label: "Data Completion Created At",
          searchable: true,
          type: "dateField",
          visible: true
        });
        streamColumns.push({
          field: "dc_by_name",
          label: "Data Completion Created By",
          searchable: true,
          type: "input",
          visible: true
        });
      }

      streamColumns.push({
        field: "created_at",
        label: "Imported Date",
        searchable: true,
        type: "dateField",
        visible: true
      });
      streamColumns.push({
        field: "updated_at",
        label: "Updated Date",
        searchable: true,
        type: "dateField",
        visible: true
      });
      streamColumns.push({
        field: "created_by_name",
        label: "Created By",
        searchable: true,
        type: "input",
        visible: true
      });
      streamColumns.push({
        field: "updated_by_name",
        label: "Updated By",
        searchable: true,
        type: "input",
        visible: true
      });

      // Store columns for this stream
      this.allStreamColumns[stream] = streamColumns;
    },

    prepareColumns(data, stream = 1) {
      // dynamically generate columns based on customer and stream
      const usedFieldNames = new Set();
      const cdf_columns = data[0]["template_fields"];
      let cdf_product_sheet = [];
      if (stream == CDFStream.BATT) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BATT
        );
      } else if (stream == CDFStream.PACK) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PACK
        );
      } else if (stream == CDFStream.WEEE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.WEEE
        );
      } else if (stream == CDFStream.BUNDLE) {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.BUNDLE
        );
      } else {
        cdf_product_sheet = cdf_columns.filter(
          e => e.field_required && e.sheet_name === CDFStream.PRODUCT_SHEET
        );
      }
      this.columns = [];
      this.tableData = [];

      // We're intentionally not loading any saved config
      // because we want all columns to be visible by default

      cdf_product_sheet.forEach((e, index) => {
        if (
          e.field_name == "WEEE" ||
          e.field_name == "BATT" ||
          e.field_name == "PACK" ||
          e.field_name == "COPY" ||
          e.field_name == "BUNDLE"
        ) {
          this.availableStream[e.field_name] = e.field_required;
        }
        if (
          (e.sheet_name == "BUNDLE INFORMATION") &
          (e.field_required == true)
        ) {
          this.availableStream["BUNDLE"] = true;
        }
        if (e.field_required == false) {
          return;
        }
        let type = "";
        let multiSelectFilter = "false";
        type = this.getFieldType(e.field_type);
        const filterKey = {};
        let allStatusVals = [];
        if (e.dropdown_field_values?.length > 0) {
          e.dropdown_field_values.forEach(element => {
            if (e.product_data_column == "product_family") {
              Object.keys(element).forEach(key => {
                this.productFamily[`${key}`] = [];
              });
              this.productFamilyDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.productFamily[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.productFamilyDropDown;
            } else if (e.product_data_column == "material_detail") {
              Object.keys(element).forEach(key => {
                this.materialDetail[`${key}`] = [];
              });
              this.materialDetailDropDown.forEach(val => {
                Object.keys(element).forEach(key => {
                  const value = element[key];
                  if (value.includes(val.name)) {
                    this.materialDetail[`${key}`].push(val.name);
                  }
                });
              });
              allStatusVals = this.materialDetailDropDown;
            } else {
              allStatusVals.push({ name: element });
            }
          });
        }
        if (e.product_data_column == "product_group") {
          allStatusVals = this.productGroupDropDown;
        }
        if (e.product_data_column == "material_general") {
          allStatusVals = this.materialGeneralDropdown;
        }
        if (e.product_data_column == "packaging_type") {
          allStatusVals = this.packagingTypeDropDown;
        }
        if (e.product_data_column == "chemistry") {
          allStatusVals = this.chemistryDropDown;
        }
        if (e.product_data_column == "packaging_level") {
          allStatusVals = this.packagingLevelDropDown;
        }
        const editableCheck = e?.editable_check ? e.editable_check : false;
        let field_name = e.product_data_column;

        // Check if this field name has been used already
        if (usedFieldNames.has(field_name)) {
          // Create a unique field name by appending an index
          field_name = `${field_name}_${index}`;
        }
        // Add to set of used field names
        usedFieldNames.add(field_name);
        const label_name =
          e.field_name.charAt(0).toUpperCase() +
          e.field_name.slice(1).toLowerCase();
        if (type == "dateField") {
          filterKey[field_name] = [];
          if (
            this.filterValues[this.stream][field_name] &&
            this.filterValues[this.stream][field_name].length > 0
          ) {
            this.filterValues[this.stream][field_name].forEach(val => {
              filterKey[field_name].push(new Date(val.value));
            });
          }
        } else if (type == "multiSelectFilter") {
          multiSelectFilter = "true";
          filterKey[field_name] = [];
          filterKey["field_name"] = "name";
          if (
            this.filterValues[this.stream][field_name] &&
            this.filterValues[this.stream][field_name].length > 0
          ) {
            this.filterValues[this.stream][field_name].forEach(val => {
              filterKey[field_name].push({ name: val.value });
            });
          }
        } else {
          filterKey[field_name] = this.filterValues[this.stream][field_name]
            ? this.filterValues[this.stream][field_name][0].value
            : "";
        }
        // Always set all columns to be visible by default
        // This ensures that all columns are checked initially
        const visible = true;

        // Skip checking saved configuration since we want all columns
        // to be visible regardless of previous settings

        this.columns.push({
          field: field_name,
          label: label_name,
          searchable: true,
          width: "300",
          filterKey: filterKey,
          type: type,
          multiSelectFilter: multiSelectFilter,
          initStatusVals: [],
          allStatusVals: allStatusVals,
          editableCheck: editableCheck,
          visible: visible
        });
      });
      this.columns.sort((a, b) => a?.template_field - b?.template_field);
      this.columns.push({
        field: "external_comment",
        label: "External User Comment",
        searchable: true,
        additionalInfo: true,
        additionalInfoIcon: "mdi  mdi-information",
        additionalInfoFieldName: "external_comment",
        filterKey: { external_comment: "" },
        type: "input",
        width: "300",
        visible: true
      });
      if (stream !== "Transactions") {
        this.columns.push({
          field: "dc_applied",
          label: "Data Completion Applied",
          additionalInfo: true,
          editableCheck: true,
          additionalInfoIcon: "mdi  mdi-information",
          additionalInfoFieldName: "dc_error",
          searchable: true,
          filterKey: {
            dc_applied: [],
            field_name: "name"
          },
          type: "multiSelectFilter",
          multiSelectFilter: true,
          allStatusVals: [{ name: "yes" }, { name: "no" }],
          width: "200",
          visible: true // Make visible by default, like other columns
        });
        this.columns.push({
          field: "data_comp_rules",
          label: "Data Completion Rule",
          searchable: true,
          editableCheck: true,
          width: "300",
          filterKey: { data_comp_rules: "" },
          type: "input",
          visible: true
        });
        this.columns.push({
          field: "dc_created_at",
          label: "Data Completion Created At",
          searchable: true,
          editableCheck: true,
          filterKey: { dc_created_at: "" },
          type: "dateField",
          dateField: true,
          dateFilterKey: "dc_created_at_key",
          width: "200",
          visible: true
        });
        this.columns.push({
          field: "dc_by_name",
          label: "Data Completion Created By",
          editableCheck: true,
          searchable: true,
          filterKey: { dc_by_name: "" },
          type: "input",
          width: "200",
          visible: true
        });
      }
      this.columns.push({
        field: "created_at",
        label: "Imported Date",
        searchable: true,
        filterKey: { created_at: "" },
        type: "dateField",
        editableCheck: true,
        dateField: true,
        width: "200",
        visible: true
      });
      this.columns.push({
        field: "updated_at",
        label: "Updated Date",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_at: "" },
        type: "dateField",
        dateField: true,
        width: "200",
        visible: true
      });
      this.columns.push({
        field: "created_by_name",
        editableCheck: true,
        label: "Created By",
        searchable: true,
        filterKey: { created_by_name: "" },
        type: "input",
        width: "200",
        visible: true
      });
      this.columns.push({
        field: "updated_by_name",
        label: "Updated By",
        editableCheck: true,
        searchable: true,
        filterKey: { updated_by_name: "" },
        type: "input",
        width: "200",
        visible: true
      });
      this.columns.push({
        field: "actions",
        label: "",
        headerClass: "is-actions",
        cellClass: "is-actions",
        visible: true,
        searchable: true,
        type: "actionSearch",
        actionSearch: true,
        filterKey: { actions: "" }
      });

      // Store columns for this stream in allStreamColumns
      this.allStreamColumns[stream] = [...this.columns];

      // Column visibility is now applied during column creation
      this.fetchProductData(stream, this.query);
      this.cdf_product_config_sheet = cdf_product_sheet;
    },

    getFieldType(value) {
      switch (value) {
        case FieldType.TEXT:
          return "input";
        case FieldType.DATE:
          return "dateField";
        case FieldType.NUMBER:
          return "input";
        case FieldType.DROPDOWN:
          return "multiSelectFilter";
        case FieldType.NUMBERRANGE:
          return "numberRange";
        default:
          return "input";
      }
    },

    fetchProductData(stream, query = "", scrollDir) {
      this.isDataLoading = true;
      this.DataManagementService.getOrUpdateProductData(
        this.customer.id,
        stream,
        this.$route.params.id,
        "",
        query,
        "",
        false,
        this.filterValues,
        true
      ).subscribe(
        response => {
          this.PreviousPageCursor = this.nextPageCursor
            ? this.nextPageCursor
            : this.PreviousPageCursor;
          this.nextPageCursor = response["next"];
          if (this.currentPage > 1) {
            this.previousData = true;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          } else {
            this.enableLoadMore = this.previousData = false;
            if (this.nextPageCursor != null) {
              this.enableLoadMore = this.nextData = true;
            } else {
              this.enableLoadMore = this.nextData = false;
            }
          }

          // if (this.loadMoreClicked) {
          //   this.displayedRecords += response["results"].length;
          // }
          this.totalRecords = response["count"];
          //this.tableData = response["results"];
          let tempData = [];
          if (scrollDir == "next") {
            if (!this.nextPageCursor) {
              this.prepareData(response["results"], scrollDir);
            } else {
              tempData = [...this.tableData, ...response["results"]];
              if (tempData.length > 100 && this.nextPageCursor != null) {
                tempData = tempData.slice(50, 150);
              }
              this.prepareData(tempData);
            }
          } else if (scrollDir == "prev") {
            if (this.currentPage == 0) {
              this.prepareData(response["results"]);
            } else {
              tempData = [...response["results"], ...this.tableData];
              if (tempData.length >= 100) {
                tempData = tempData.slice(0, 100);
              }
              this.prepareData(tempData);
            }
          } else {
            this.prepareData(response["results"]);
          }

          this.isDataLoading = false;
        },
        e => {
          this.handleApiError(e);
          this.nextData = false;
          this.isDataLoading = false;
        }
      );
    },
    prepareData(data) {
      const dataList = [];
      for (const report in data) {
        const reportData = data[report];
        reportData["updated_at"] = dayjs(reportData["updated_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        reportData["created_at"] = dayjs(reportData["created_at"]).format(
          "YYYY-MM-DD, HH:mm"
        );
        if (reportData["dc_created_at"]) {
          reportData["dc_created_at"] = dayjs(
            reportData["dc_created_at"]
          ).format("YYYY-MM-DD, HH:mm");
        }
        reportData["actions"] = true;
        dataList.push(reportData);
      }

      if (this.nextPageCursor == null) {
        // Force Vue reactivity by creating a new array reference
        this.tableData = [...this.tableData, ...dataList];
        if (this.currentPage > 1) {
          this.currentPage = this.currentPage - 1;
          if (this.currentPage == 1) {
            this.previousData = false;
          }
        } else {
          this.currentPage = this.currentPage - 1;
          this.previousData = false;
        }
      } else {
        // Create a new array reference to trigger Vue reactivity
        this.tableData = [...dataList];
      }

      // For single row selection mode
      // Check if we have a selection stored for this page
      if (
        this.map1.has(this.currentPage) &&
        this.map1.get(this.currentPage).length > 0
      ) {
        // Restore the single selected row for this page
        const selectedIndex = this.map1.get(this.currentPage)[0];
        if (selectedIndex < this.tableData.length) {
          this.checkedRow = [this.tableData[selectedIndex]];
        } else {
          this.checkedRow = [];
        }
      } else {
        // No selection on this page
        this.checkedRow = [];
      }

      this.isDataLoading = false;
    },
    fetchCDFProductData(customerId) {
      this.isDataLoading = true;
      // First fetch the dropdown data, THEN fetch the CDF product data
      this.DataManagementService.getAdditionalDropdowns(customerId).subscribe(
        response => {
          // Populate all dropdown arrays with the response data
          this.productFamilyDropDown = this.prepareDropDownArray(
            response.product_family
          );
          this.productGroupDropDown = this.prepareDropDownArray(
            response.product_group
          );
          this.materialDetailDropDown = this.prepareDropDownArray(
            response.material_detail
          );
          this.materialGeneralDropdown = this.prepareDropDownArray(
            response.material_general
          );
          this.packagingTypeDropDown = this.prepareDropDownArray(
            response.packaging_type
          );
          this.packagingLevelDropDown = this.prepareDropDownArray(
            response.packaging_level
          );
          this.chemistryDropDown = this.prepareDropDownArray(
            response.chemistry
          );
          // NOW fetch the CDF product data (which will use the populated dropdowns)
          this.CDFProductDataService.getAll(this.customer.id, true).subscribe(
            cdfResponse => {
              this.cdf_product_sheet = cdfResponse;
              if (cdfResponse.length > 0) {
                // Prepare columns for all streams to populate the filter modal
                this.allStreams.forEach(streamName => {
                  this.prepareColumnsForStream(cdfResponse, streamName);
                });
                // Then prepare columns for the current stream and fetch data
                this.prepareColumns(cdfResponse, this.stream);
              }
              this.isDataLoading = false;
            },
            e => {
              this.handleApiError(e);
              this.isDataLoading = false;
            }
          );
        },
        e => {
          console.error("Error fetching dropdowns:", e);
          this.isDataLoading = false;
        }
      );
    },
    fetchCustomerData() {
      this.isDataLoading = true;
      this.customerDataService.getParentCustomerList().subscribe(
        response => {
          const data = response.sort((a, b) => (a.name > b.name ? 1 : -1));
          this.customers = data;
          this.isDataLoading = false;
        },
        () => {
          this.isDataLoading = false;
        }
      );
    },
    backToImportForm() {
      this.$router.push({
        name: "datamanagement.importform",
        params: {
          customer: this.customer,
          importType: { id: "1", name: "Products" }
        }
      });
    },
    checkSize() {
      screenPixelSize = screen.width;
      pixelRatio =
        window.devicePixelRatio ||
        window.screen.availWidth / document.documentElement.clientWidth;
      pixelRatio = pixelRatio.toFixed(1);
      if (
        (screenPixelSize > 1024 &&
          screenPixelSize < 1281 &&
          pixelRatio == 1.5) ||
        (screenPixelSize > 1580 && screenPixelSize < 1921 && pixelRatio == 1.5)
      ) {
        this.subHeight = this.subHeight - 15;
      }
      this.$refs.circul8Table.$refs.multiselect &&
        this.$refs.circul8Table.$refs.multiselect.forEach(element => {
          element.deactivate();
        });
      this.$refs.circul8Table.$refs.dropdown &&
        this.$refs.circul8Table.$refs.dropdown.forEach(element => {
          element.isActive = false;
        });
      this.$refs.circul8Table.$refs.datePicker &&
        this.$refs.circul8Table.$refs.datePicker.forEach(element => {
          element.closePopup();
        });
    },

    onDropdownActiveChange(isActive) {
      // When a dropdown is opened, adjust its height
      if (isActive) {
        this.$nextTick(() => {
          this.adjustHeight();
        });
      }
    },

    adjustHeight() {
      // Set up dropdown dimensions
      this.$nextTick(() => {
        const dropdownLists = document.querySelectorAll(".filter-config-list");
        dropdownLists.forEach(list => {
          // Apply styles
          list.style.maxHeight = `${this.newTableHeight - 40}px`;
          list.style.overflowY = "auto";
        });
      });
    }
  },
  watch: {
    // Watch for match button clicks
    columns: {
      handler(newColumns) {
        // Update selectAll checkbox when columns change
        this.selectAll = newColumns.every(
          column => column.field === "actions" || column.visible !== false
        );
      },
      deep: true,
      immediate: true
    },
    matchClicked() {
      this.map1 = new Map();
      this.checkedRow = [];
      this.isCheckedAll = false;
      this.checkedData = [];
      this.checkedDataMap = new Map();
      this.tableData = [];

      // Notify parent of cleared selections
      this.$emit("selectedRows", [], this.customer?.id || null);

      // Fetch fresh data with current query to preserve filters and pagination
      const queryToUse = this.query || "";
      this.fetchProductData(this.stream, queryToUse);
    }
  }
};
</script>

<style scoped>
/* Standard dropdown styling with improved scrolling and fixed header */
:deep(.filter-config-modal-body) {
  display: flex;
  flex-direction: column;
  max-height: 70vh;
  width: 300px;
  padding: 0 !important;
}

:deep(.filter-config-header) {
  position: sticky;
  top: 0;
  background-color: white;
  padding: 15px 15px 10px;
  border-bottom: 1px solid #f0f0f0;
  z-index: 2;
}

:deep(.filter-config-list) {
  overflow-y: auto;
  padding: 10px 15px;
  scrollbar-width: thin;
}

/* Ensure checkbox items wrap properly */
:deep(.dropdown-item) {
  padding: 5px 10px;
  white-space: normal;
  line-height: 1.4;
  height: auto;
}

:deep(.checkbox) {
  overflow-wrap: break-word;
  word-break: break-word;
}
</style>
